var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTitle',{attrs:{"title":"Preguntas y Respuestas"}}),_c('FirstBanner'),_c('div',{staticClass:"container"},[(!_vm.loading)?_c('ExpandableList',{attrs:{"items":_vm.faqs,"link":_vm.link}}):_c('LoaderComponent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }